import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RegistrationsProvider } from './context/RegistrationsContext';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { EventsHome } from './pages/EventsHome';
import { EventDetail } from './pages/EventDetail';
import { PastEvents } from './pages/PastEvents';
import { AdminDesk } from './pages/AdminDesk';
export function App() {
  return <RegistrationsProvider data-id="element-0" data-mp="2rikrdguv4vgt">
      <BrowserRouter data-id="element-1" data-mp="2mmcbg18ucy8l">
        <div className="flex min-h-screen w-full flex-col bg-paper" data-id="element-2" data-mp="2mn5b6i9dunh8">
          <SiteHeader data-id="element-3" data-mp="31b8l22qjqjbb" />
          <div className="flex-1" data-id="element-4" data-mp="31brz38d2snk2">
            <Routes data-id="element-5" data-mp="31ctf7r8y808n">
              <Route path="/" element={<EventsHome data-id="element-7" data-mp="2wjqgl4pbe0ll" />} data-id="element-6" data-mp="2wk06yte9u9rt" />
              <Route path="/events/:slug" element={<EventDetail data-id="element-9" data-mp="28ufo0ai4bcij" />} data-id="element-8" data-mp="2wifhhi6tdh0t" />
              <Route path="/past-events" element={<PastEvents data-id="element-11" data-mp="28sl4n0mhvsgk" />} data-id="element-10" data-mp="28tmi1bqzgr1g" />
              <Route path="/admin" element={<AdminDesk data-id="element-13" data-mp="23w4ek0vqj40u" />} data-id="element-12" data-mp="23vcikoy874a1" />
              <Route path="*" element={<EventsHome data-id="element-15" data-mp="23ti7e2craqj5" />} data-id="element-14" data-mp="23ut9lxqjzq85" />
            </Routes>
          </div>
          <SiteFooter data-id="element-16" data-mp="3ijfvu1ti80fo" />
        </div>
      </BrowserRouter>
    </RegistrationsProvider>;
}